import { render } from "./modal-download.vue?vue&type=template&id=004a8e65&scoped=true&ts=true"
import script from "./modal-download.vue?vue&type=script&lang=ts"
export * from "./modal-download.vue?vue&type=script&lang=ts"

import "./modal-download.vue?vue&type=style&index=0&id=004a8e65&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-004a8e65"]])

export default __exports__